import { LearnEventType } from './learn.domain';

export interface LearnEvents {
  events: Array<LearnEvent>;
  numberOfEvents: number;
}

export interface LearnEvent {
  type: LearnEventType;
  title: string;
  description: string;
  timeBreakdown?: string;
  imageUrl: string;
  startTime: string;
  endTime: string;
  locale?: string;
  on24ExternalLink: string;
  registered: boolean;
  eventId: string;
  speakers?: Array<Speaker>;
  knowledgeLevel?: string;
}

export interface Speaker {
  name: string;
  title: string;
  company: string;
  description: string;
}

export interface RegistrationRequest {
  email: string;
}

export interface RegistrationResponse {
  eventId: string;
  emailAddress: string;
  updateExistingRegFailed: boolean;
  addRegFailed: boolean;
}

export type LearnEventRegistration = 'SUBSEQUENT_REGISTRATION' | 'REGISTRATION' | 'CHANGE_EMAIL' | 'REGISTRATION_SUCCESS' | 'CHANGE_EMAIL_REGISTRATION_SUCCESS';

export enum LearnEventSort {
  START_TIME = 'START_TIME',
  START_TIME_DESC = 'START_TIME_DESC'
}

export enum LearnEventFilter {
  ALL_EVENTS = 'ALL_EVENTS',
  WEBINARS = 'WEBINARS',
  MASTER_CLASSES = 'MASTER_CLASSES'
}

